export enum RegisterOriginType {
    None = 0,
    External = 1,
    Internal = 2,
    Transferred = 3,
    Tokenizadora = 4
}
